<div class="content-body">
  <div class="filter-container">
    <div class="text-center mt-3" style="color: white;">
      <h2>Ofertas de crédito pendientes <span class="txtbienvenida-2">por aprobar</span></h2>
    </div>
    <div class="container mt-5">
      <form [formGroup]="filterForm">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="idSolicitud" class="form-label">Nº de solicitud</label>
              <input type="text" class="form-control" formControlName="idSolicitud">
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="fechaRecepcion" class="form-label">Fecha de recepción</label>
              <input type="date" class="form-control" formControlName="fechaRecepcion">
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="idEstadoSolicitud" class="form-label">Estado de la solicitud</label>
              <select class="form-control" formControlName="idEstadoSolicitud">
                <option [value]="null">Seleccione...</option>
                @for (estado of estados; track estado) {
                  <option [value]="estado.idEstadoSolicitudIntermediario">
                    {{ estado.nombre }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-3 col-xs-4">
            <div class="mb-3">
              <label for="idDepartamento" class="form-label">Departamento</label>
              <select class="form-control" formControlName="idDepartamento" (change)="getCiudades($event.target.value)">
                <option [value]="null">Seleccione una opción</option>
                @for (departamento of departamentos; track departamento) {
                  <option [value]="departamento.idDepartamento">
                    {{ departamento.nombreDepartamento }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-3 col-xs-4">
            <div class="mb-3">
              <label for="idCiudad" class="form-label">Ciudad</label>
              <select class="form-control" formControlName="idCiudad">
                <option [value]="null">Seleccione una opción</option>
                @for (ciudad of ciudades; track ciudad) {
                  <option [value]="ciudad.idCiudad">
                    {{ ciudad.nombreCiudad }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="getSolicitudes()">Filtrar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="limpiarFiltro()">Limpiar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button class="btn  btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">Volver</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  @if (solicitudesPendientes.length>0) {
    <div class="table-container">
      <div class="container">
        <table class="table table-bordered">
          <thead id="general">
            <tr>
              <th>Nº de solicitud</th>
              <th>Fecha de recepción</th>
              <th>Nombre del solicitante</th>
              <th>Tipo y número de documento</th>
              <th>Monto solicitado</th>
              <th>Estado de la solicitud</th>
              <th>Ubicación</th>
              <th id="acciones">Acciones</th>
            </tr>
          </thead>
          <tbody id="general_body">
            @for (solicitud of solicitudesPendientes; track solicitud; let i = $index) {
              <tr>
                <td scope="row" id="id-sol"><a (click)="verDetalleSolicitud(i)" [routerLink]="['../../../solicitud/intermediario', solicitud.numeroSolicitud]">{{solicitud.numeroSolicitud}}</a></td>
                <td>{{solicitud.fechaRecepcion | date: 'dd/MM/yyyy' : 'UTC'}}</td>
                <td>{{solicitud.nombreDeSolicitante}}</td>
                <td>{{solicitud.tipoYNumeroDeDocumento}}</td>
                <td>{{solicitud.montoSolicitado | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                <td>{{solicitud.estadoSolicitud}}</td>
                <td>
                  {{ !solicitud.ciudad.data[0] ? '' : solicitud.ciudad.data[0].nombreCiudad }} - {{ !solicitud.departamento.data[0] ? '' : solicitud.departamento.data[0].nombreDepartamento }}
                </td>
                <td>
                  @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 4 || solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 3) {
                    <div>
                      @if (i==habilitarCampos) {
                        <button type="button" class="btn-icon-style btn border-0" (click)="devolver(i)">
                          <i class="fas fa-undo-alt text-danger"></i>
                        </button>
                      }
                      @if (i==habilitarCampos && solicitud.idEstadoSolicitud_NeoEstadoSolicitud==4) {
                        <button type="button" class="btn-icon-style btn border-0" (click)="negar(i)">
                          <i class="fas fa-times-circle text-danger"></i>
                        </button>
                      }
                      @if (i==habilitarCampos) {
                        <button type="button" class="btn-icon-style btn border-0" (click)="aprobar(i)">
                          <i class="fas fa-check-circle text-success"></i>
                        </button>
                      }
                      <span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" title="Ver detalle solicitud">
                        <button type="button" class="btn-icon-style btn border-0" (click)="verDetalleSolicitud(i)">
                          <i class="fas fa-eye text-primary"></i>
                        </button>
                      </span>
                      @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud==4) {
                        <span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" title="Ver detalle oferta revisor">
                          <button type="button" class="btn-icon-style btn border-0" (click)="verDetalleOfertaRevisor(i)">
                            <i class="fas fa-eye text-primary"></i>
                          </button>
                        </span>
                      }
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination  (event)="changePage($event)" [paginaActual]="paginaActual"
        [totalPaginas]="totalPaginas" style="width: auto"></app-pagination>
      </div>
    </div>
  }
  @if (solicitudesPendientes.length<1) {
    <div class="row justify-content-md-center text-center mt-5">
      <div class="col-12 col-sm-12">
        <h3>No tiene solicitudes pendientes</h3>
      </div>
    </div>
  }
</div>
<app-footer></app-footer>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
